module.exports = __webpack_public_path__ + "img/water.46b8631f.svg";